import React from 'react';

import { motion } from 'framer-motion';

import styled from 'styled-components';

import ICONS from '../../../../constants/icons';

const SwirlingBackground: React.FC = () => {
    return (
        <SvgWrapper>
            <PaintSplat
                animate={{
                    rotate: [0, 360],
                }}
                transition={{
                    repeat: Infinity,
                    duration: 8,
                    ease: 'linear',
                }}
                style={{
                    top: '-5%',
                    left: '4%',
                    transform: 'rotate(-30deg) scale(1.0)',
                }}
            >
                <ICONS.coverSwirl2 width="500px" height="500px" />
            </PaintSplat>

            <PaintSplat
                animate={{
                    rotate: [0, 360],
                }}
                transition={{
                    repeat: Infinity,
                    duration: 9,
                    ease: 'linear',
                }}
                style={{
                    top: '60%',
                    left: '10%',
                    transform: 'rotate(-30deg) scale(1.0)',
                }}
            >
                <ICONS.coverSwirl2 width="600px" height="600px" />
            </PaintSplat>
            <PaintSplat
                animate={{
                    rotate: [0, 360],
                }}
                transition={{
                    repeat: Infinity,
                    duration: 8,
                    ease: 'linear',
                }}
                style={{
                    top: '-10%',
                    left: '55%',
                    transform: 'rotate(-30deg) scale(1.0)',
                }}
            >
                <ICONS.coverSwirl2 width="800px" height="900px" />
            </PaintSplat>

            <PaintSplat
                animate={{
                    rotate: [0, 360],
                }}
                transition={{
                    repeat: Infinity,
                    duration: 10,
                    ease: 'linear',
                }}
                style={{
                    top: '20%',
                    left: '15%',
                    transform: 'rotate(-30deg) scale(2.0)',
                }}
            >
                <ICONS.coverSwirl2 width="800px" height="600px" />
            </PaintSplat>

            <PaintSplat
                animate={{
                    rotate: [0, 360],
                }}
                transition={{
                    repeat: Infinity,
                    duration: 10,
                    ease: 'linear',
                }}
                style={{
                    top: '60%',
                    left: '35%',
                    transform: 'rotate(-30deg) scale(1.0)',
                }}
            >
                <ICONS.coverSwirl2 width="1200px" height="1200px" />
            </PaintSplat>

            <PaintSplat
                animate={{
                    rotate: [0, 360],
                }}
                transition={{
                    repeat: Infinity,
                    duration: 7.5,
                    ease: 'linear',
                }}
                style={{
                    top: '30%',
                    left: '75%',
                    transform: 'rotate(-30deg) scale(2.0)',
                }}
            >
                <ICONS.coverSwirl2 width="900px" height="900px" />
            </PaintSplat>
        </SvgWrapper>
    );
};

export default SwirlingBackground;
const SvgWrapper = styled(motion.div)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
});

const PaintSplat = styled(motion.div)({
    position: 'absolute',
    opacity: 0.25,
    filter: 'blur(30px)',
});
